import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {CommentsRepository} from "./comments.repository";
import {CommentsFactory} from "./comments.factory";

export class CommentsDomainService extends BaseDomainService {
  static injectables = [...BaseManagedService.injectables, CommentsRepository, CommentsFactory, DomainRequestManager];
}
